import {colors} from 'shells/colors/colors';

import type {LeadFitScore} from 'nutshell-graphql-types';

import {BACKGROUND_PATH, ARC_SECTIONS, NEEDLE_PATH, centerX, centerY, GAUGE_CONFIG} from './consts';

interface Props {
    score: LeadFitScore;
    width?: number;
}

export function LeadFitGauge(props: Props) {
    const {width = 80} = props;
    const config = GAUGE_CONFIG[props.score];

    if (!config) {
        return null;
    }

    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} viewBox='0 0 83 40' fill='none'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d={BACKGROUND_PATH}
                fill={colors.black}
                fillOpacity={0.16}
            />
            {config.fillAmount >= 1 && (
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d={ARC_SECTIONS.left}
                    fill={config.color}
                />
            )}
            {config.fillAmount >= 2 && (
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d={ARC_SECTIONS.top}
                    fill={config.color}
                />
            )}
            {config.fillAmount >= 3 && (
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d={ARC_SECTIONS.right}
                    fill={config.color}
                />
            )}
            <path
                d={NEEDLE_PATH}
                fill={colors.grey}
                transform={`rotate(${config.rotation}, ${centerX}, ${centerY})`}
            />
        </svg>
    );
}
